
import { useIntegrations } from '@/hooks/integrations';
import { NuvemshopIntegration } from './NuvemshopIntegration';
import { Skeleton } from '@/components/ui/skeleton';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { AlertTriangle } from 'lucide-react';

export const IntegrationsContainer = () => {
  console.log('🔄 IntegrationsContainer: Renderizando componente');
  
  const { integrations, isLoading } = useIntegrations();

  console.log('📊 IntegrationsContainer: Estado atual', {
    isLoading,
    integrationsCount: integrations?.length || 0,
    integrations: integrations
  });

  if (isLoading) {
    console.log('⏳ IntegrationsContainer: Exibindo skeleton de loading');
    return (
      <div className="space-y-6">
        <Skeleton className="h-48 w-full" />
        <Skeleton className="h-48 w-full" />
      </div>
    );
  }

  try {
    const nuvemshopIntegration = integrations?.find(i => i.integration_type === 'nuvemshop');

    console.log('🔍 IntegrationsContainer: Integrações encontradas', {
      nuvemshop: !!nuvemshopIntegration,
      nuvemshopStatus: nuvemshopIntegration?.status,
      nuvemshopConfig: nuvemshopIntegration?.config
    });

    return (
      <div className="space-y-6">
        <NuvemshopIntegration integration={nuvemshopIntegration} />
      </div>
    );
  } catch (error) {
    console.error('❌ IntegrationsContainer: Erro ao renderizar', error);
    
    return (
      <Card className="border-red-200">
        <CardHeader>
          <CardTitle className="text-red-600 flex items-center gap-2">
            <AlertTriangle className="h-5 w-5" />
            Erro no Componente de Integrações
          </CardTitle>
          <CardDescription>
            Erro: {error instanceof Error ? error.message : 'Erro desconhecido'}
          </CardDescription>
        </CardHeader>
        <CardContent>
          <button 
            onClick={() => window.location.reload()}
            className="bg-red-600 text-white px-4 py-2 rounded-md hover:bg-red-700"
          >
            Recarregar Página
          </button>
        </CardContent>
      </Card>
    );
  }
};
